
<template>
    <div class="foot noSel">
		<div class="footer">
			<div class="contents">
				<div class="left"> 
					<div class="logo">
						<!-- <div class="logoName">零距离</div>
						<div class="logoDev">Zero Distance</div> -->
						<img src="../../assets/images/logoFoot.png" alt="">
					</div>
					<div class="hlex" >
						<!-- © 2020, Amazon Services LLC. All Rights Reserved. An Amazon -->
						<!-- <span @click="goBa">粤ICP备20068530号</span> -->
					</div>
				</div>
					<div class="center">
					<div class="dew">
						<span class="tit">底部导航</span>
					</div>
					<div class="dew">
						<span @click="goLink(0)">首页</span>
						<!-- <span @click="goLink(3)">关于我们</span> -->
						<!-- <span @click="goLink(2)">模拟注册</span> -->
						<span @click="goLink(2)">模拟注册</span>
					</div>
					<div class="dew">
						<span @click="goLink(4)">用户协议</span>
						<!-- <span @click="goLink(3)">课程</span>
						<span @click="goLink(1)">亚马逊卖家后台模拟</span> -->
						
					</div>
				</div>
				<div class="right" >
					<div class="dew dewCon">
						<span class="tit" v-if="false">联系我们 <img src="../../assets/images/footPhne.png" alt=""><img src="../../assets/images/footWx.png" alt=""></span>
						<span v-if="false" >注册专业指导：18138242593</span>
						<span v-if="false" >商务合作：18520881181</span>
					</div>
					<div class="dew dewFlex" v-if="false">
						<div  class="img">
							<div class="nas">注册专业指导</div>
							<img src="../../assets/images/footCode2.png" />
						</div>
						<div  class="img" style="margin-left: 40px;">
							<div class="nas" style="margin-left: -8px;">{{chatImg.title}}</div>
							<img :src="chatImg.url" />
						</div>
					</div>
				</div>
			</div>
			<div class="footerTi">Copyright  2020~2021 珈烨网络科技 zc.510jl.com  版权所有<span @click="goBa">粤ICP备20068530号</span></div> 
		</div>
    </div>
</template>
<script>
// import qs from 'qs'
export default {
  name: "foot",
   data: function() {
    return {
	}
  },
  components: {
  },
  computed: {
    chatImg() {
      return this.$store.getters.chatImg;
    }
  },
  created(){
  },
   methods: {
	goBa(){
		window.open('http://beian.miit.gov.cn/',true)
	},
	goLink(e){
		if(e==0){
			location.href=this.interfaceJson.localUrl
		}else if(e==1){
			location.href=this.interfaceJson.localUrl+'VirtualAdmin'
		}else if(e==2){
			location.href=this.interfaceJson.localUrl+'VirtualReg'
		}else if(e==3){
			location.href=this.interfaceJson.localUrl+'course'
		}else if(e==4){
			window.open('https://zc.510jl.com/#/UserHelp')
			
		}else{
			location.href=this.interfaceJson.localUrl+'About'
		}
		
	}
  },
  
};
</script>
<style lang="scss" scoped>
.footerTi{
	text-align: center;
	color: #fff;
	font-size: 13px;
	margin-top: 15px;
	span{
		margin-left: 10px;
		cursor: pointer;
	}
	span:hover{
		color: #367dff;
	}
}
.foot{
	margin-top: -3px;
}
.footer{
	height: 258px;
    background-color: #202b39;
    left: 0;
    bottom: 0;
    width: 100%;
}
.contents{
	max-width: 1242px;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	.left{
		width: 182px;
		position: relative;
		.logo{
			text-align: center;
			width: 104px;
			margin: 0 auto;
			padding-top: 112px;
			img{
				width: 125px;
			}
		}
		.logo .logoName{
			font-size: 20px;
			line-height:28px;
			// padding-top:18px;
			color: #fff;
		}
		.logoDev{
			height: 18px;
			border:4px solid #FBCA61;
			line-height: 18px;
			font-size:12px;
			border-top: 0;
			padding: 0 4px;
			font-weight:500;
			color: #fff;
		}
		.hlex{
			text-align: center;
			font-size: 12px;
			color: #fff;
			line-height:17px;
			margin-top: 29px;
		}
		.hlex span{ 
			margin-left: 15px;
			cursor: pointer;
		}

	}
	.left::after{
		content: '';
		position: absolute;
		height:60px;
		width: 1px;
		background-color: #707070;
		right: -40%;
		top: 99.5px;
	}
	// .left::after{
	// 	content: '';
	// 	position: absolute;
	// 	height:60px;
	// 	width: 1px;
	// 	background-color: #707070;
	// 	right: -185%;
	// 	top: 99.5px;
	// }
	.center{
		position: relative;
		width:230px;
		padding-top: 82px;
		.dew{
			span{
				cursor: pointer;
			}
		}
	}
	.center::after{
		content: '';
		position: absolute;
		height:60px;
		width: 1px;
		background-color: #707070;
		right: -38%;
		top: 99.5px;
	}
	.right{
		padding-top: 82px;	
		display:flex;
		.dew{
			display: block;
			.tit{
				margin-top: 0;
				font-size: 14px;
				img{
					width: 20px;
					height: 20px;
					vertical-align: middle;
					margin-left: 5px;
				}
			}
			span{
				display: block;
				font-size: 14px;
				margin-top: 20px;
			}
		}
		.dewFlex{
			display: flex;
		}
		.img{
			margin-top: -15px;
			.nas{
				color: #fff;
				text-align: center;
				font-size: 12px;
			}
			img{
				display: block;
				width: 100px;
				height: 100px;
				margin-top: 10px;
			}
		}
		.dewCon{
			margin-right: 40px;
		}
	}
	.dew{
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
		span{
			font-size:12px;
			color: #fff;
			
		}
		.tit{
			font-size: 14px;
		}
	}
}
	
</style>
